import { render } from "./NumberChip.vue?vue&type=template&id=6027510f&scoped=true"
import script from "./NumberChip.vue?vue&type=script&lang=js"
export * from "./NumberChip.vue?vue&type=script&lang=js"

import "./NumberChip.vue?vue&type=style&index=0&id=6027510f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6027510f"

export default script